import React from 'react'
import ffffff from '../image/ffffff.avif'
import { styled } from '@mui/system'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}))

function DM_FAQ_page() {
  return (
    <div>
      <div className="mt-5">
        <div className="container pt-3">
          <div className="text-center Curriculum_Main_text">
            <div className="">
              <h2 className="display-6">Frequently Asked Questions</h2>
              <p className="pt-2">
                Our Responses to Your Inquiries: Unblocking the Way to Clarity
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-5">
              <div className="FAQ_img">
                <img
                  src={ffffff}
                  onContextMenu={(e) => e.preventDefault()}
                ></img>
              </div>
            </div>
            <div className="col-md-7 pt-5 d-none d-md-block">
              <div className="pt-5">
                <div className="pt-5">
                  <div className="pt-5">
                    <DM_FAQ />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 d-sm-block d-md-none mb-5">
              <DM_FAQ />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

function DM_FAQ() {
  const classes = useStyles()
  const [expanded, setExpanded] = React.useState(false)

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }

  return (
    <div>
      <div className={classes.root}>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel1'}
          onChange={handleChange('panel1')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              What skills are essential for a successful career in Digital
              Marketing?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Essential skills include SEO, SEM, content marketing, social media
              marketing, email marketing, data analysis, and proficiency with
              tools like Google Analytics, AdWords, and various CMS platforms.
              Creativity, communication, and analytical thinking are also key.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel2'}
          onChange={handleChange('panel2')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2bh-content"
            id="panel2bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              Do I need a degree to work in Digital Marketing?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              While a degree in marketing, communications, or business can be
              helpful, it’s not mandatory. Many professionals break into the
              field through certifications (e.g., Google Ads, HubSpot, etc.) and
              hands-on experience, as digital marketing relies heavily on
              practical skills.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel3'}
          onChange={handleChange('panel3')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3bh-content"
            id="panel3bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              What are the career growth opportunities in Digital Marketing?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Career paths include roles like SEO Specialist, Social Media
              Manager, Content Strategist, Digital Marketing Manager, PPC
              Specialist, and more. Over time, marketers can progress to senior
              roles such as Head of Digital Marketing or Chief Marketing Officer
              (CMO).
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel4'}
          onChange={handleChange('panel4')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel4bh-content"
            id="panel4bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              How can I keep up with the latest trends in Digital Marketing?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Stay updated through industry blogs, podcasts, webinars, and
              certifications from platforms like Google, HubSpot, or Moz.
              Attending conferences, networking, and joining online marketing
              communities are also effective ways to stay informed.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel5'}
          onChange={handleChange('panel5')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel5bh-content"
            id="panel5bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              What does a typical day look like for a Digital Marketer?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              A day may include creating or curating content, analyzing campaign
              performance, optimizing ads, conducting keyword research, engaging
              with audiences on social media, and coordinating with
              cross-functional teams (e.g., designers, developers) for campaign
              execution.
            </Typography>
          </AccordionDetails>
        </Accordion>
      </div>
    </div>
  )
}
export default DM_FAQ_page
